// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Wallet Welcome Modal */
.wallet-welcome-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  backdrop-filter: blur(12px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.wallet-welcome-modal {
  background: linear-gradient(135deg, rgba(10, 30, 60, 0.95), rgba(20, 50, 90, 0.95));
  border-radius: 20px;
  padding: 40px;
  max-width: 500px;
  width: 90%;
  box-shadow: 
    0 0 60px rgba(0, 180, 255, 0.3),
    0 0 120px rgba(0, 180, 255, 0.15);
  border: 1px solid rgba(0, 180, 255, 0.3);
  animation: slideUp 0.4s cubic-bezier(0.22, 1, 0.36, 1);
}

@keyframes slideUp {
  from {
    transform: translateY(60px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.wallet-welcome-header {
  text-align: center;
  margin-bottom: 32px;
}

.wallet-welcome-logo {
  font-size: 64px;
  margin-bottom: 16px;
  filter: drop-shadow(0 0 20px rgba(0, 180, 255, 0.5));
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

.wallet-welcome-title {
  font-size: 28px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 8px 0;
  text-shadow: 0 0 20px rgba(0, 180, 255, 0.6);
}

.wallet-welcome-subtitle {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
}

.wallet-welcome-body {
  margin-bottom: 32px;
}

.wallet-welcome-feature {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: rgba(0, 180, 255, 0.05);
  border-radius: 12px;
  margin-bottom: 12px;
  border: 1px solid rgba(0, 180, 255, 0.1);
  transition: all 0.3s ease;
}

.wallet-welcome-feature:hover {
  background: rgba(0, 180, 255, 0.1);
  border-color: rgba(0, 180, 255, 0.3);
  transform: translateX(4px);
}

.wallet-welcome-icon {
  font-size: 32px;
  flex-shrink: 0;
  filter: drop-shadow(0 0 10px rgba(0, 180, 255, 0.4));
}

.wallet-welcome-feature h3 {
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  margin: 0 0 4px 0;
}

.wallet-welcome-feature p {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
}

.wallet-welcome-footer {
  display: flex;
  gap: 12px;
}

.wallet-welcome-btn {
  flex: 1 1;
  padding: 16px 24px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.wallet-welcome-btn-secondary {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: rgba(255, 255, 255, 0.8);
}

.wallet-welcome-btn-secondary:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

.wallet-welcome-btn-primary {
  background: linear-gradient(135deg, #0084ff, #0066cc);
  border: 1px solid rgba(0, 180, 255, 0.5);
  color: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 132, 255, 0.3);
}

.wallet-welcome-btn-primary:hover {
  background: linear-gradient(135deg, #0099ff, #0077dd);
  box-shadow: 0 6px 30px rgba(0, 132, 255, 0.5);
  transform: translateY(-2px);
}

.wallet-welcome-metamask-icon {
  font-size: 20px;
}

/* Mobile responsive */
@media (max-width: 640px) {
  .wallet-welcome-modal {
    padding: 28px;
    max-height: 90vh;
    overflow-y: auto;
  }

  .wallet-welcome-title {
    font-size: 24px;
  }

  .wallet-welcome-logo {
    font-size: 48px;
  }

  .wallet-welcome-footer {
    flex-direction: column;
  }

  .wallet-welcome-btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/WalletWelcome.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,mFAAmF;EACnF,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV;;qCAEmC;EACnC,wCAAwC;EACxC,sDAAsD;AACxD;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,oDAAoD;EACpD,wCAAwC;AAC1C;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oDAAoD;AACtD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;EACrD,wCAAwC;EACxC,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;IACb,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* Wallet Welcome Modal */\n.wallet-welcome-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.9);\n  backdrop-filter: blur(12px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  animation: fadeIn 0.3s ease-out;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.wallet-welcome-modal {\n  background: linear-gradient(135deg, rgba(10, 30, 60, 0.95), rgba(20, 50, 90, 0.95));\n  border-radius: 20px;\n  padding: 40px;\n  max-width: 500px;\n  width: 90%;\n  box-shadow: \n    0 0 60px rgba(0, 180, 255, 0.3),\n    0 0 120px rgba(0, 180, 255, 0.15);\n  border: 1px solid rgba(0, 180, 255, 0.3);\n  animation: slideUp 0.4s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(60px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.wallet-welcome-header {\n  text-align: center;\n  margin-bottom: 32px;\n}\n\n.wallet-welcome-logo {\n  font-size: 64px;\n  margin-bottom: 16px;\n  filter: drop-shadow(0 0 20px rgba(0, 180, 255, 0.5));\n  animation: pulse 2s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n}\n\n.wallet-welcome-title {\n  font-size: 28px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0 0 8px 0;\n  text-shadow: 0 0 20px rgba(0, 180, 255, 0.6);\n}\n\n.wallet-welcome-subtitle {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.7);\n  margin: 0;\n}\n\n.wallet-welcome-body {\n  margin-bottom: 32px;\n}\n\n.wallet-welcome-feature {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 16px;\n  background: rgba(0, 180, 255, 0.05);\n  border-radius: 12px;\n  margin-bottom: 12px;\n  border: 1px solid rgba(0, 180, 255, 0.1);\n  transition: all 0.3s ease;\n}\n\n.wallet-welcome-feature:hover {\n  background: rgba(0, 180, 255, 0.1);\n  border-color: rgba(0, 180, 255, 0.3);\n  transform: translateX(4px);\n}\n\n.wallet-welcome-icon {\n  font-size: 32px;\n  flex-shrink: 0;\n  filter: drop-shadow(0 0 10px rgba(0, 180, 255, 0.4));\n}\n\n.wallet-welcome-feature h3 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 0 0 4px 0;\n}\n\n.wallet-welcome-feature p {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.6);\n  margin: 0;\n}\n\n.wallet-welcome-footer {\n  display: flex;\n  gap: 12px;\n}\n\n.wallet-welcome-btn {\n  flex: 1;\n  padding: 16px 24px;\n  border-radius: 12px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.wallet-welcome-btn-secondary {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.wallet-welcome-btn-secondary:hover {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: rgba(255, 255, 255, 0.3);\n  transform: translateY(-2px);\n}\n\n.wallet-welcome-btn-primary {\n  background: linear-gradient(135deg, #0084ff, #0066cc);\n  border: 1px solid rgba(0, 180, 255, 0.5);\n  color: #ffffff;\n  box-shadow: 0 4px 20px rgba(0, 132, 255, 0.3);\n}\n\n.wallet-welcome-btn-primary:hover {\n  background: linear-gradient(135deg, #0099ff, #0077dd);\n  box-shadow: 0 6px 30px rgba(0, 132, 255, 0.5);\n  transform: translateY(-2px);\n}\n\n.wallet-welcome-metamask-icon {\n  font-size: 20px;\n}\n\n/* Mobile responsive */\n@media (max-width: 640px) {\n  .wallet-welcome-modal {\n    padding: 28px;\n    max-height: 90vh;\n    overflow-y: auto;\n  }\n\n  .wallet-welcome-title {\n    font-size: 24px;\n  }\n\n  .wallet-welcome-logo {\n    font-size: 48px;\n  }\n\n  .wallet-welcome-footer {\n    flex-direction: column;\n  }\n\n  .wallet-welcome-btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
